import React from 'react';
import PropTypes from 'prop-types';
import logo from './logo.jpg';

const IconLogo = props => {
  const { className, format, ...rest } = props;

  if (format === 'desktop') {
    return <img className={className} src={logo} />;
  }

  return <img className={className} src={logo} />;
};

const { string } = PropTypes;

IconLogo.defaultProps = {
  className: null,
};

IconLogo.propTypes = {
  className: string,
};

export default IconLogo;
